export enum MetaPixelEvent {
  INITIATE_CHECKOUT = 'InitiateCheckout',
  VIEW_CONTENT = 'ViewContent',
}
